<template>
    <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
        <my-input
            v-model="form.current_password"
            type="password"
            name="current_password"
            :error="form.errors.get('current_password')"
            :autofucos="true"
            class="mb-6"
            label="Current Password"
            placeholder="Current Password"
        />

        <my-input
            v-model="form.new_password"
            type="password"
            name="new_password"
            :error="form.errors.get('new_password')"
            :autofucos="true"
            class="mb-6"
            label="New Password"
            placeholder="New Password"
        />

        <my-button :loading="submitting" class="btn btn-primary btn-lg btn-block rounded-full" @click="submitForm">
            <i class="fa fa-save"></i> Update My Password
        </my-button>
    </form>
</template>

<script>
import Form from '../../forms/form';

export default {
    mixins: [require('../../mixins/accepts-user').default],

    data() {
        return {
            form: new Form({
                current_password: null,
                new_password: null
            }),
            submitting: false
        };
    },

    methods: {
        submitForm() {
            this.submitting = true;

            this.form
                .put(`/api/users/${this.userId}/password`)
                .then(() => flash.success())
                .catch(() => flash.error({ message: 'It seems like you have submitted invalid data.' }))
                .then(() => {
                    this.form.new_password = null;
                    this.form.current_password = null;
                    this.submitting = false;
                });
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        }
    }
};
</script>
